export default __webpack_public_path__ + "static/media/Resume.7da88341.pdf";